import STATUSES from './statuses';
import DEFAULT_THUMBNAIL_SIZE from './default-thumbnail-size';
import IMAGE_PLACEMENTS from './image-placements';

export default {
  IMAGE_ACCEPT_TYPE: '.jpg, .png, .gif, .jpeg, .svg',
  ALLOWED_IMAGE_FORMATS: ['.png', '.jpg', '.jpeg', '.gif', '.svg'],
  STATUSES,
  DEFAULT_THUMBNAIL_SIZE,
  IMAGE_PLACEMENTS,
  ASYNC_JOB_POLLING_TIMEOUT: 500,
  SIZE_LIMIT_CODE: 'external_asset_size_validation_failed',
  WRONG_FILE_FORMAT_CODE: 'external_asset_format_validation_failed',
  ASSET_DOWNLOAD_FAILED: 'external_asset_download_failed',
};
